import request from '@/axios/request.js'

const downLoad = {
  bind(el, binding) {
    if (binding.value.url) {
      el.addEventListener('click', () => {
        const a = document.createElement('a');
        const url = binding.value.url;
        // 将url装成blob地址  可用fetch
        request({ url, method: 'get', responseType: 'blob'}).then((res) => new Blob([res])).then(blob => {
          a.href = URL.createObjectURL(blob);
          a.download = binding.value.name || '';
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(a.href);  // 释放URL对象
          document.body.removeChild(a);
        })
      })
    }
  }
};
export { downLoad }




// WEBPACK FOOTER //
// ./src/components/permission/permission.js